import { render, staticRenderFns } from "./UserLink.vue?vue&type=template&id=59ec708c"
import script from "./UserLink.vue?vue&type=script&lang=js"
export * from "./UserLink.vue?vue&type=script&lang=js"
import style0 from "./UserLink.vue?vue&type=style&index=0&id=59ec708c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports